/* ============================================================
   Lune Features — sticky ATC, quick view, social proof,
   recently viewed, count-up stats, countdown, scroll progress
   ============================================================ */
(function(){
  var d=document;

  /* ---------- Scroll progress bar ---------- */
  function scrollProgress(){
    var bar=d.querySelector('.lune-progress');
    if(!bar){bar=d.createElement('div');bar.className='lune-progress';d.body.appendChild(bar);}
    function upd(){var h=d.documentElement;var max=h.scrollHeight-h.clientHeight;bar.style.width=(max>0?(h.scrollTop/max*100):0)+'%';}
    window.addEventListener('scroll',upd,{passive:true});upd();
  }

  /* ---------- Count-up stats ---------- */
  function countUp(){
    var nums=d.querySelectorAll('[data-count]');
    if(!nums.length)return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(!en.isIntersecting)return;
        var el=en.target,target=parseFloat(el.getAttribute('data-count')),dec=(el.getAttribute('data-dec')||0)|0,suf=el.getAttribute('data-suffix')||'';
        var t0=null,dur=1400;
        function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1);var ease=1-Math.pow(1-p,3);var val=(target*ease).toFixed(dec);el.innerHTML=Number(val).toLocaleString()+(suf?'<span class="u">'+suf+'</span>':'');if(p<1)requestAnimationFrame(step);}
        requestAnimationFrame(step);io.unobserve(el);
      });
    },{threshold:.4});
    nums.forEach(function(n){io.observe(n);});
  }

  /* ---------- Sticky mobile ATC ---------- */
  function stickyAtc(){
    var form=d.querySelector('product-form-component form, form[action*="/cart/add"]');
    var anchor=d.querySelector('.lune-sticky-atc');
    if(!form||!anchor)return;
    var realBtn=form.querySelector('[type="submit"], button[name="add"]');
    var btn=anchor.querySelector('button');
    if(btn&&realBtn){btn.addEventListener('click',function(){realBtn.click();});}
    var trigger=form.getBoundingClientRect().bottom;
    function onScroll(){
      var atcInView = realBtn ? realBtn.getBoundingClientRect().bottom>0 && realBtn.getBoundingClientRect().top<window.innerHeight : true;
      if(window.scrollY>520 && !atcInView) anchor.classList.add('is-show');
      else anchor.classList.remove('is-show');
    }
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  }

  /* ---------- Recently viewed (localStorage) ---------- */
  function recentlyViewed(){
    try{
      var meta=d.querySelector('[data-lune-product]');
      if(meta){
        var key='lune_recent';
        var arr=JSON.parse(localStorage.getItem(key)||'[]');
        var handle=meta.getAttribute('data-lune-product');
        arr=arr.filter(function(h){return h!==handle;});
        arr.unshift(handle);arr=arr.slice(0,8);
        localStorage.setItem(key,JSON.stringify(arr));
      }
      var host=d.querySelector('[data-lune-recent]');
      if(host){
        var list=JSON.parse(localStorage.getItem('lune_recent')||'[]').filter(function(h){return h!==(host.getAttribute('data-exclude')||'');}).slice(0,6);
        if(!list.length){host.closest('section')&&(host.closest('section').style.display='none');return;}
        Promise.all(list.map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}))
        .then(function(prods){
          var html=prods.filter(Boolean).map(function(p){
            var img=p.featured_image||(p.images&&p.images[0])||'';
            var price=(p.price/100).toFixed(2);
            return '<a class="lune-card" href="/products/'+p.handle+'"><div class="lune-card__media"><img src="'+img+'&width=400" alt="'+(p.title||'').replace(/"/g,'')+'" loading="lazy"></div><div class="lune-card__body"><span class="lune-card__title">'+p.title+'</span><span class="lune-card__price"><span class="now">AED '+price+'</span></span></div></a>';
          }).join('');
          host.innerHTML=html;
        });
      }
    }catch(e){}
  }

  /* ---------- Quick view ---------- */
  function quickView(){
    var overlay;
    function ensure(){
      if(overlay)return overlay;
      overlay=d.createElement('div');overlay.className='lune-qv-overlay';
      overlay.innerHTML='<div class="lune-qv"><div class="lune-qv__media"></div><div class="lune-qv__body"><button class="lune-qv__close" aria-label="Close">&times;</button><div class="lune-qv__content"></div></div></div>';
      d.body.appendChild(overlay);
      overlay.addEventListener('click',function(e){if(e.target===overlay||e.target.classList.contains('lune-qv__close'))close();});
      return overlay;
    }
    function close(){overlay&&overlay.classList.remove('is-open');}
    function open(handle){
      ensure();
      fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
        var img=p.featured_image||(p.images&&p.images[0]);
        var onSale=p.compare_at_price>p.price;
        var price='AED '+(p.price/100).toFixed(2);
        var was=onSale?'<span class="was">AED '+(p.compare_at_price/100).toFixed(2)+'</span>':'';
        overlay.querySelector('.lune-qv__media').innerHTML='<img src="'+img+'&width=900" alt="'+(p.title||'').replace(/"/g,'')+'">';
        overlay.querySelector('.lune-qv__content').innerHTML=
          '<span class="lune-qv__brand">'+(p.vendor||'')+'</span>'
          +'<h3 class="lune-qv__title">'+p.title+'</h3>'
          +'<div class="lune-qv__price">'+price+was+'</div>'
          +'<div class="lune-qv__desc">'+(p.description||'').replace(/<[^>]+>/g,' ').slice(0,260)+'\u2026</div>'
          +'<button class="lune-btn lune-btn--ink" data-qv-add="'+(p.variants&&p.variants[0]&&p.variants[0].id||'')+'" style="border:none;cursor:pointer">Add to cart</button>'
          +'<a class="link lune-qv__full" href="/products/'+p.handle+'">View full details</a>';
        overlay.classList.add('is-open');
      });
    }
    d.addEventListener('click',function(e){
      var qv=e.target.closest('[data-quickview]');
      if(qv){e.preventDefault();open(qv.getAttribute('data-quickview'));return;}
      var add=e.target.closest('[data-qv-add]');
      if(add){var id=add.getAttribute('data-qv-add');if(!id)return;add.textContent='Adding\u2026';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(){add.textContent='Added \u2713';d.dispatchEvent(new CustomEvent('cart:refresh'));setTimeout(close,800);});
      }
    });
  }

  /* ---------- Social proof toasts ---------- */
  function socialProof(){
    var data=window.LUNE_PROOF;
    if(!data||!data.items||!data.items.length)return;
    var toast,i=0;
    function el(){
      if(toast)return toast;
      toast=d.createElement('div');toast.className='lune-toast';
      toast.innerHTML='<button class="lune-toast__x" aria-label="Dismiss">&times;</button><img class="lune-toast__img" alt=""><div class="lune-toast__txt"></div>';
      d.body.appendChild(toast);
      toast.querySelector('.lune-toast__x').addEventListener('click',function(){toast.classList.remove('is-show');clearTimeout(window.__luneProofT);});
      return toast;
    }
    function show(){
      var it=data.items[i%data.items.length];i++;
      var t=el();
      t.querySelector('.lune-toast__img').src=it.img||'';
      t.querySelector('.lune-toast__txt').innerHTML='<strong>'+it.name+'</strong> in '+it.city+' ordered<br>'+it.product+'<span class="t">'+(it.time||'Just now')+' \u00b7 Verified</span>';
      t.classList.add('is-show');
      window.__luneProofT=setTimeout(function(){t.classList.remove('is-show');window.__luneProofT=setTimeout(show,7000);},5500);
    }
    setTimeout(show,(data.delay||6)*1000);
  }

  /* ---------- Countdown ---------- */
  function countdown(){
    d.querySelectorAll('[data-countdown]').forEach(function(el){
      var end=new Date(el.getAttribute('data-countdown')).getTime();
      if(isNaN(end))return;
      function tick(){
        var diff=Math.max(end-Date.now(),0);
        var dd=Math.floor(diff/864e5),hh=Math.floor(diff%864e5/36e5),mm=Math.floor(diff%36e5/6e4),ss=Math.floor(diff%6e4/1e3);
        var map={d:dd,h:hh,m:mm,s:ss};
        el.querySelectorAll('[data-cd]').forEach(function(u){var k=u.getAttribute('data-cd');u.querySelector('b').textContent=String(map[k]).padStart(2,'0');});
        if(diff>0)setTimeout(tick,1000);
      }
      tick();
    });
  }

  function init(){scrollProgress();countUp();stickyAtc();recentlyViewed();quickView();socialProof();countdown();}
  if(d.readyState!=='loading')init();else d.addEventListener('DOMContentLoaded',init);
})();
